import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getGroupsForDropdown,
  getFactoryByGroupID,
  SaveWarehouseDetails,
  GetWarehouseDetails,
  GetwarehouseDetailsBywarehouseID,
  UpdateWarehouse
};

async function getGroupsForDropdown() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getFactoryByGroupID(groupID) {
  let response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
  let factoryArray = [];
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
};

async function SaveWarehouseDetails(saveModel) {
  const response = await CommonPost(
    '/api/Warehouse/SaveWarehouseDetails',
    null,
    saveModel
  );
  return response;
}

async function GetWarehouseDetails(factoryID, groupID) {
  const response = await CommonGet(
    '/api/Warehouse/GetWarehouseDetails',
    'FactoryID=' +
    parseInt(factoryID) +
    '&GroupID=' +
    parseInt(groupID)
  );
  return response;
}

async function GetwarehouseDetailsBywarehouseID(warehouseID) {
  const response = await CommonGet(
    '/api/Warehouse/GetwarehouseDetailsBywarehouseID',
    'warehouseID=' + parseInt(warehouseID)
  );
  return response.data;
}

async function UpdateWarehouse(updateModel) {
  const response = await CommonPost(
    '/api/Warehouse/UpdateWarehouse',
    null,
    updateModel
  );
  return response;
}
